import React, { Component } from 'react';
import './CandidateUpdateRequest.css';
import LoadingOverlay from 'react-loading-overlay';
import { Redirect } from 'react-router-dom';
import Logo from '../assets/img/iprofile-logo.png'


export class CandidateUnsubscribe extends Component {
    static displayName = CandidateUnsubscribe.name;

  constructor(props) {
    super(props);
    this.state = {
      isOverlayActive: false,
      isRedirect: false,
      connectedCompanies: []
    };
    this.resumeFileInput = React.createRef();
  }

  handleSubmit = async (event) => {
    if (this.state.isOverlayActive === true) return;
    event.preventDefault();
    this.setState({ 'isOverlayActive': true });

    try {
      let token = this.props.match.params.token;
      
      await fetch(`api/Unsubscribe/${token}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state) });

      this.setState({ 'isOverlayActive': false });
      this.setState({'isRedirect': true});

    } catch (error) {
        //DISPLAY ERROR
      this.setState({ 'isOverlayActive': false });
    }
  }

  async componentDidMount() {
    this.setState({ 'isOverlayActive': true });
    try {
      let token = this.props.match.params.token;
      let response = await fetch(`api/Unsubscribe/${token}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
      if (response.ok) {
        let data = await response.json();
          this.setState({ 'companyName': data.company });
      }
    } catch (error) {
    }
    this.setState({ 'isOverlayActive': false });
  }

  render() {
    if (this.state.isRedirect) {
      return <Redirect to='/success/candidate-update' />
    }
    return (
      <LoadingOverlay active={this.state.isOverlayActive} spinner>
        <div style={{ padding: '20px 0' }}>
          <div style={{ padding: '20px 0' }}><img src={Logo} height="100px" alt="logo" /></div>
          <form onSubmit={this.handleSubmit}>
            <div> {/*Row*/}
              <div className="half-column"> {/*Column*/}
                            Are you sure you want to Unsubscribe from iProfile?
              </div>
            </div>
            <div><input type="submit" value="Yes, Unsubscribe me"></input></div>
          </form>
        </div>
      </LoadingOverlay>
    )
  }
}